const env = (import.meta as unknown as { env: Record<string, string> }).env;

export default {
  APP_URL: window.location.origin.toString(),
  WS_URL: env.VITE_WS_URL,
  SERVICES_URL: env.VITE_SERVICES_URL,
  WHEELS_URL: env.VITE_WHEELS_URL,
  PASS_URL: env.VITE_PASS_URL,
  CALENDAR_URL: env.VITE_CALENDAR_URL,
  DEALS_URL: env.VITE_DEALS_URL,

  TRANSITION: env.VITE_TRANSITION === 'true',
  SENTRY_DSN: env.VITE_SENTRY_DSN,

  CONSEILLER_URL: env.VITE_CONSEILLER_URL,
  CMS_URL: env.VITE_CMS_URL,
  DOCUMENTS_URL: env.VITE_DOCUMENTS_URL,
};
